import { render, staticRenderFns } from "./GerenciarFeriasPage.vue?vue&type=template&id=2b5b3428"
import script from "./GerenciarFeriasPage.vue?vue&type=script&lang=js"
export * from "./GerenciarFeriasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports